import { render, staticRenderFns } from "./ProductionPerShift.vue?vue&type=template&id=c2cf05cc"
import script from "./ProductionPerShift.vue?vue&type=script&lang=js"
export * from "./ProductionPerShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports